import { render } from "./SourceSegmentView.vue?vue&type=template&id=1c044f68&scoped=true&ts=true"
import script from "./SourceSegmentView.vue?vue&type=script&lang=ts"
export * from "./SourceSegmentView.vue?vue&type=script&lang=ts"

import "./SourceSegmentView.vue?vue&type=style&index=0&id=1c044f68&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c044f68"]])

export default __exports__